export const storage = {
  getItem(key) {
    try {
      return Promise.resolve(localStorage.getItem(key));
    } catch {
      return Promise.resolve(null);
    }
  },
  setItem(key, value) {
    try {
      localStorage.setItem(key, value);
    } catch {
      // ignore
    }
    return Promise.resolve();
  },
  removeItem(key) {
    try {
      localStorage.removeItem(key);
    } catch {
      // ignore
    }
    return Promise.resolve();
  },
  multiGet(keys) {
    return Promise.resolve(
      keys.map((key) => [key, localStorage.getItem(key)]),
    );
  },
  multiSet(pairs) {
    pairs.forEach(([key, value]) => {
      if (value != null) localStorage.setItem(key, value);
    });
    return Promise.resolve();
  },
  multiRemove(keys) {
    keys.forEach((key) => localStorage.removeItem(key));
    return Promise.resolve();
  },
};
